import {
    putProviderLoading,
    putProviderRequest,
    putProviderSuccess,
    putProviderReject,
    putProviderReset
} from "../../actions/provider/put";

export const putProvider = (formData) => async (dispatch, getState) => {
    dispatch(putProviderLoading());
    try {
        const { data } = await putProviderRequest(formData, getState);
        dispatch(putProviderSuccess(data))
    } catch (error) {
        dispatch(putProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(putProviderReset()) }, 3000);
    }
    return Promise.resolve();
};